// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clamped-content[data-v-f0cb27c0]{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;line-clamp:2;max-height:100%}.divider-line[data-v-f0cb27c0]{width:100%;border-top:2.5px solid #2b3378}", ""]);
// Exports
module.exports = exports;
